// Generated file - do not change manually!

/**
 * Available Panel Accessible Landmark Roles.
 */
export enum PanelAccessibleRole {
  /**
   * Represents the ARIA role <code>complementary</code>. A section of the page, designed to be complementary to the main content at a similar level in the DOM hierarchy.
   */
  Complementary = 'Complementary',

  /**
   * Represents the ARIA role <code>Form</code>. A landmark region that contains a collection of items and objects that, as a whole, create a form.
   */
  Form = 'Form',

  /**
   * Represents the ARIA role <code>Region</code>. A section of a page, that is important enough to be included in a page summary or table of contents.
   */
  Region = 'Region'
}
